// Subscription Store

const state = {
  pending: false,
  latestPostTV: [],
}

const getters = {}

const actions = {
  getLatestPostsTv({ commit }) {
    return new Promise(resolve => {
      commit('SET_PENDING')
      this.api.items
      .getItems('latest_posts_tv')
      .then(({ data }) => {
        commit('SET_LATEST_POSTS_TV_DATA', data)
        commit('SET_PENDING')
        resolve()
      })
    })
  },
}

const mutations = {
  SET_PENDING: state => {
    state.pending = !state.pending
  },
  SET_LATEST_POSTS_TV_DATA(state, data) {
    state.latestPostTV = data
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
